import React, { Component } from 'react';
import {Route, Switch, withRouter} from "react-router";
import Login from "./security/login";
import Master from "./Master/Master";

class App extends Component {

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (snapshot !== null) {
        }
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            sessionStorage.setItem("triggerAppId", window.AppInstanceId);
        }
        return null;
    }

    render() {
        return (
            <React.Fragment>
                <Switch>
                    <Route path="/login" render={() => <Login/>}/>
                    <Route path="/" render={() => <Master/>}/>
                </Switch>
            </React.Fragment>
        );
    }
}

export default withRouter(App);
